import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    offset: theme.mixins.toolbar,  // https://material-ui.com/components/app-bar/#fixed-placement
  }),
);


export default function AppBarOffset() {
  const classes = useStyles();

  return (
    <div className={classes.offset} />
  )
}